import React from "react";
import { shortDateString } from "../../../utils/dateFormatters";
import { stringLengthLimiter } from "../../../utils/utils";
import Tooltip from "../../Tooltip";

interface PlainTextDisplayProps {
  value: any;
  fieldType: string;
  maxLength?: number;
  rightAlignCurrency?: boolean;
}

const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};

const PlainTextDisplay: React.FC<PlainTextDisplayProps> = ({
  value,
  fieldType = "text",
  maxLength = 120,
  rightAlignCurrency = true,
}) => {
  return (
    <div className="relative group flex items-start">
      {(() => {
        switch (fieldType) {
          case "currency":
            return (
              <span
                className={`${rightAlignCurrency ? "text-right" : ""} w-full`}
              >
                {formatCurrency(value ?? 0)}
              </span>
            );
          case "number":
            return <>{(value ?? 0).toLocaleString()}</>;
          case "percent":
            return <>{value ? `${value}%` : "N/A"}</>;
          case "date":
            return <>{value ? shortDateString(value) : "N/A"}</>;
          case "select":
            return (
              <div className="border rounded-lg shadow p-1 px-2 text-center w-fit">
                {value}
              </div>
            );
          case "textArray":
            return (
              <div className="flex flex-wrap">
                {value?.map((item: any, index: number) => (
                  <Tooltip content={item} display={item?.length > maxLength}>
                    <div className="p-1 border m-1 rounded-lg overflow-hidden text-ellipsis">
                      {stringLengthLimiter(item ?? "-", maxLength)}
                    </div>
                  </Tooltip>
                ))}
              </div>
            );
          case "boolean":
            return <input type="checkbox" checked={value} readOnly disabled />;
          case "text":
          default:
            return (
              <Tooltip content={value} display={value?.length > maxLength}>
                <div className="overflow-hidden text-ellipsis">
                  {stringLengthLimiter(
                    (JSON.stringify(value) ?? "-").replaceAll('"', ""),
                    maxLength
                  )}
                </div>
              </Tooltip>
            );
        }
      })()}
    </div>
  );
};

export default PlainTextDisplay;
